import React, { useState, useEffect, useRef } from "react";
import { hasInvoiceEdits } from "../../../assets/reusableComponents/invoiceEdits";
import "../../../assets/reusableComponents/InvoiceEditHighlight.scss";
import "./ViewInvoices.scss"; // Import CSS

//import components
import DropdownSelect from "../../../assets/reusableComponents/dropDownSelect";
import { ReactComponent as CalenderIcon } from "../../../assets/icons/custom-calender-icon.svg";

//import resize function
import { vw, vh } from "../../../assets/reusableComponents/resizeFunction";

//redux imports
import { useSelector, useDispatch } from "react-redux";
import { listRentInvoices } from "../../../../redux/slices/sliceActions";
import OriginalInvoiceModal from "./OriginalInvoiceModal";
import ViewOriginalButton from "./ViewOriginalButton";
import MissingWaterInvoices from "./MissingWaterInvoices";

const ViewInvoicesTable = ({ onNavigateToPage }) => {
  // redux methods
  const dispatch = useDispatch();
  const { allLandlordInvoices, properties, rentInvoices } = useSelector(
    (state) => state.landlordslice
  );

  const [invoicesToDisplay, setInvoicesToDisplay] = useState([]);
  const [originalInvoice, setOriginalInvoice] = useState(null);
  const hasEditedInvoices = invoicesToDisplay.some(hasInvoiceEdits);
  const columnCount = hasEditedInvoices ? 11 : 10;
  useEffect(() => {
    // Assuming allLandlordInvoices is an array of invoice objects
    if (allLandlordInvoices) {
      const formatedInvoices = allLandlordInvoices.map((invoice) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        return {
          id: invoice?._id,
          house_no: invoice?.tenant?.house?.house_no,
          rent: invoice?.rent,
          property: invoice?.property.name,
          water: invoice?.water,
          garbage: invoice?.garbage,
          service_charge: invoice?.service_charge,
          late_fee: invoice?.late_fee,
          arrears: invoice?.arrears,
          unpaid_deposit: invoice?.unpaid_deposit,
          dueDate: formatDate(invoice?.createdAt),
          amount: invoice?.total,
          status: invoice?.status,
          isEdited: invoice?.isEdited,
          originalCharges: invoice?.originalCharges,
          isCreated: invoice?.isCreated,
          exi: invoice?.exi,
          mgmt_fee: invoice?.mgmt_fee,
        };
      });
      setInvoicesToDisplay(formatedInvoices);
    }
  }, [allLandlordInvoices]);

  //Navigation variables
  const [hovered, setHovered] = useState(false);
  const [hoveredSecond, setHoveredSecond] = useState(false);

  // apartment  variables
  const [apartmentChoices, setApartmentChoices] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState("All Apartments");
  useEffect(() => {
    if (Object.keys(properties).length > 0) {
      setApartmentChoices([...properties.map((property) => property.name)]);
    }
  }, [properties]);

  //date variables
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const daySuffix = (day) => {
      if (day > 3 && day < 21) return "th";
      switch (day % 10) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        default:
          return "th";
      }
    };

    return `${day}${daySuffix(day)} ${month} ${year}`;
  };
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  //month variables
  const [selectedMonth, setSelectedMonth] = useState("All months");
  const monthChoices = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  //year variables
  const [selectedYear, setSelectedYear] = useState("All years");
  const currentYear = new Date().getFullYear();
  const yearChoices = Array.from({ length: 21 }, (_, i) => currentYear - i);

  // Filter button clicked state
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [checkedFilters, setCheckedFilters] = useState(null);
  const fetchedInvoices = rentInvoices?.data ?? rentInvoices;
  const waterInvoicesNotCreated = filterButtonClicked && checkedFilters &&
    fetchedInvoices?.meterReadings && !fetchedInvoices?.isPropertyCreatedInSameMonth;

  const applyFilters = () => {
    if (
      selectedApartment === "Select Apartment" ||
      selectedMonth === "All months" ||
      selectedYear === "All years"
    ) {
      alert("Please fill in all the fields before applying filters.");
      return;
    }
    setFilterButtonClicked(true);
    setOriginalInvoice(null);
    setIsFetching(true);
    const selectedApartmentID = properties.find(
      (property) => property.name == selectedApartment
    )?._id;

    if (selectedApartmentID) {
      const monthNumber = monthChoices.indexOf(selectedMonth) + 1;
      setCheckedFilters({ apartment: selectedApartment, month: selectedMonth, year: selectedYear });

      dispatch(
        listRentInvoices({
          property_id: selectedApartmentID,
          month: monthNumber,
          year: selectedYear,
        })
      )
        .unwrap()
        .finally(() => {
          setIsFetching(false);
        });
    } else {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    console.log("Rent Invoices:", rentInvoices);
    const data = rentInvoices?.data ?? rentInvoices;
    if (filterButtonClicked && data?.meterReadings && !data?.invoices) {
      setInvoicesToDisplay([]);
      return;
    }
    if (data?.invoices && filterButtonClicked) {
      const formatedInvoices = data.invoices.map((invoice) => {
        const formatDate = (dateString) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        return {
          id: invoice?._id,
          house_no: invoice?.tenant?.house?.house_no,
          rent: invoice?.rent,
          property: invoice?.property.name,
          water: invoice?.water,
          garbage: invoice?.garbage,
          service_charge: invoice?.service_charge,
          late_fee: invoice?.late_fee,
          arrears: invoice?.arrears,
          unpaid_deposit: invoice?.unpaid_deposit,
          dueDate: formatDate(invoice?.createdAt),
          amount: invoice?.total,
          status: invoice?.status,
          isEdited: invoice?.isEdited,
          originalCharges: invoice?.originalCharges,
          isCreated: invoice?.isCreated,
          exi: invoice?.exi,
          mgmt_fee: invoice?.mgmt_fee,
        };
      });

      setInvoicesToDisplay(formatedInvoices);
    }
  }, [rentInvoices]);

  return (
    <div className="view-invoices-rent">
      <div className="title-section">
        <div className="title-and-description">
          <div className="title">View rent invoices</div>
          <div className="description">View rent invoice history</div>
        </div>
      </div>
      <div className="horizontal-line"></div>
      <div className="filters-container">
        <div className="drop-down">
          <div className="box-title">Apartment Choice</div>
          <div className="select">
            <DropdownSelect
              choices={apartmentChoices}
              defaultChoice={selectedApartment}
              onSelect={setSelectedApartment}
            />
          </div>
        </div>
        <div className="box">
          <div className="box-title">Month</div>
          <div className="select">
            <DropdownSelect
              choices={monthChoices}
              defaultChoice={selectedMonth}
              onSelect={setSelectedMonth}
              backgroundColor={"transparent"}
              textColor={"#192a3a"}
              border={"1px solid #ccc"}
            />
          </div>
        </div>
        <div className="box">
          <div className="box-title">Year</div>
          <div className="select">
            <DropdownSelect
              choices={yearChoices}
              defaultChoice={selectedYear}
              onSelect={setSelectedYear}
              backgroundColor={"transparent"}
              textColor={"#192a3a"}
              border={"1px solid #ccc"}
            />
          </div>
        </div>
        <div className="apply-filters-button">
          <div className="box-title">Confirm </div>
          <button onClick={applyFilters}>Apply Filters</button>
        </div>
      </div>
      <div className="horizontal-line"></div>

      <div className="table-container">
        <table className="invoices-table">
          <thead>
            <tr className="table-row">
              <th className="title">House</th>
              <th className="title">Rent</th>
              <th className="title">Water</th>
              <th className="title">Garbage</th>
              <th className="title">Service Fee</th>
              <th className="title">Late Fee</th>
              <th className="title">Arrears</th>
              <th className="title">Unpaid Deposit</th>
              <th className="title">Amount</th>
              <th className="title">Status</th>
              {hasEditedInvoices && <th className="title">View original</th>}
            </tr>
          </thead>
          <tbody>
            {isFetching ? (
              <tr>
                <td colSpan={columnCount}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px', gap: '10px' }}>
                    <div className="spinner" style={{ width: "40px", height: "40px", border: "4px solid #00B1A9", borderTop: "4px solid transparent", borderRadius: "50%", animation: "spin 1s linear infinite" }}></div>
                    Fetching rent invoices...
                  </div>
                </td>
              </tr>
            ) : invoicesToDisplay.length === 0 ? (
              <tr>
                <td colSpan={columnCount} style={{ textAlign: "center", padding: "20px" }}>
                  {waterInvoicesNotCreated ? (
                    <MissingWaterInvoices {...checkedFilters} onNavigateToPage={onNavigateToPage} />
                  ) : "No invoices to display"}
                </td>
              </tr>
            ) : (
              invoicesToDisplay.map((invoice) => (
              <tr className={`invoice-row ${hasInvoiceEdits(invoice) ? "invoice-row-edited" : ""}`} title={hasInvoiceEdits(invoice) ? "Manually changed" : undefined} key={invoice?.id}>
                <td className="data">{invoice?.house_no}</td>
                <td className="data">{invoice?.rent}</td>
                <td className="data">{invoice?.water}</td>
                <td className="data">{invoice?.garbage}</td>
                <td className="data">{invoice?.service_charge}</td>
                <td className="data">{invoice?.late_fee}</td>
                <td className="data">{invoice?.arrears}</td>
                <td className="data">{invoice?.unpaid_deposit}</td>
                <td className="data">{invoice?.amount}</td>
                <td className={invoice?.status}>
                  <span className="status">{invoice?.status}</span>
                </td>
                {hasEditedInvoices && (
                  <td className="data">
                    {hasInvoiceEdits(invoice) && <ViewOriginalButton onClick={() => setOriginalInvoice(invoice)} />}
                  </td>
                )}
              </tr>
            )))}
          </tbody>
        </table>
      </div>
      {originalInvoice && <OriginalInvoiceModal invoice={originalInvoice} onClose={() => setOriginalInvoice(null)} />}
    </div>
  );
};

export default ViewInvoicesTable;
